import React from 'react';

export default function InlineFieldError({ message }) {
  if (!message) return null;
  return (
    <p
      className="text-xs mt-1"
      style={{ fontFamily: 'var(--font-caption)', color: '#EF4444' }}
      role="alert"
    >
      {message}
    </p>
  );
}
